import type { EpisodeAuditionSupport } from '@/_contract/episodeSupport';
import type { ScenePlanAuditionPreview } from '@/_contract/scenePlanAudition';

export async function loadScenePlanAuditions(support: EpisodeAuditionSupport, signal?: AbortSignal): Promise<ScenePlanAuditionPreview[]> {
    const response = await fetch(support.apiUrl, { signal, cache: 'no-store' });
    if (!response.ok) {
        const result = await response.json();
        throw new Error(result.error ?? `Audition loading failed (${response.status}).`);
    }
    const previews: ScenePlanAuditionPreview[] = await response.json();
    if (!Array.isArray(previews)) throw new Error('Invalid audition list response.');
    previews.forEach(preview => support.register(preview));
    return previews;
}
